import { useContext, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import axios from 'axios';

const Login = () => {
  const [searchParams] = useSearchParams();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

   useEffect(() => {
    // Redirect on component mount
    const authenticated = searchParams.get("authenticated");
    if (authenticated === "success") {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }

    if (authenticated !== "success") {
      window.location.href = "https://integration.emetrotel.net/auth/login";
    }
  }, []);

  return (
    <div className="content_bg text-center">
        <h4 style={{ color: "whitesmoke", paddingTop: "25px" }}>
          {isAuthenticated === false ? "Redirecting to login..."  :  "Authentication successful!"}          
        </h4>
    </div>
  );
};

export default Login;
